import React from 'react';

import * as S from './HighlightFeatureCardUI.styles';

const HighlightFeatureCardUI = ({icon, description, isListView = false, numberOfLines}) => {
  return (
    <S.FeatureItem isListView={isListView}>
      <S.FeatureItemImgWrapper isListView={isListView}>
        <S.FeatureItemImg src={icon} />
      </S.FeatureItemImgWrapper>
      <S.FeatureItemDesc title={description} isListView={isListView} numberOfLines={numberOfLines}>
        {description}
      </S.FeatureItemDesc>
    </S.FeatureItem>
  );
};

export default HighlightFeatureCardUI;
